/**
 * @generated SignedSource<<d8edd44d25387fb911acb1db4ca9bd5f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "formId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "formId",
    "variableName": "formId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "formName",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "formTitle",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "formSubtitle",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "vppId",
  "storageKey": null
},
v8 = [
  {
    "kind": "Literal",
    "name": "orderBy",
    "value": "Q_ORDER_ASC"
  }
],
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "formDetailId",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "qOrder",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "qKey",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "qName",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "qType",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "qDefault",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "qOptional",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "qWidth",
  "storageKey": null
},
v17 = [
  {
    "kind": "Literal",
    "name": "orderBy",
    "value": "DISPLAY_ORDER_ASC"
  }
],
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "formDetailValuesId",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayOrder",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nodeId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FormEditQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "FormT",
        "kind": "LinkedField",
        "name": "formTByFormId",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "VppTsConnection",
            "kind": "LinkedField",
            "name": "vppTsByFormId",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "VppT",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v7/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v8/*: any*/),
            "concreteType": "FormDetailTsConnection",
            "kind": "LinkedField",
            "name": "formDetailTsByFormId",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "FormDetailT",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/),
                  {
                    "alias": null,
                    "args": (v17/*: any*/),
                    "concreteType": "FormDetailValuesTsConnection",
                    "kind": "LinkedField",
                    "name": "formDetailValuesTsByFormDetailId",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      {
                        "alias": "values",
                        "args": null,
                        "concreteType": "FormDetailValuesT",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                          (v18/*: any*/),
                          (v19/*: any*/),
                          (v20/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "formDetailValuesTsByFormDetailId(orderBy:\"DISPLAY_ORDER_ASC\")"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "formDetailTsByFormId(orderBy:\"Q_ORDER_ASC\")"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FormEditQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "FormT",
        "kind": "LinkedField",
        "name": "formTByFormId",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "VppTsConnection",
            "kind": "LinkedField",
            "name": "vppTsByFormId",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "VppT",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v7/*: any*/),
                  (v21/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v8/*: any*/),
            "concreteType": "FormDetailTsConnection",
            "kind": "LinkedField",
            "name": "formDetailTsByFormId",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "FormDetailT",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/),
                  {
                    "alias": null,
                    "args": (v17/*: any*/),
                    "concreteType": "FormDetailValuesTsConnection",
                    "kind": "LinkedField",
                    "name": "formDetailValuesTsByFormDetailId",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      {
                        "alias": "values",
                        "args": null,
                        "concreteType": "FormDetailValuesT",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                          (v18/*: any*/),
                          (v19/*: any*/),
                          (v20/*: any*/),
                          (v21/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "formDetailValuesTsByFormDetailId(orderBy:\"DISPLAY_ORDER_ASC\")"
                  },
                  (v21/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": "formDetailTsByFormId(orderBy:\"Q_ORDER_ASC\")"
          },
          (v21/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6e10b48926472c9d0d0997bf0522514f",
    "id": null,
    "metadata": {},
    "name": "FormEditQuery",
    "operationKind": "query",
    "text": "query FormEditQuery(\n  $formId: UUID!\n) {\n  formTByFormId(formId: $formId) {\n    formName\n    formTitle\n    formSubtitle\n    description\n    vppTsByFormId {\n      totalCount\n      nodes {\n        vppId\n        nodeId\n      }\n    }\n    formDetailTsByFormId(orderBy: Q_ORDER_ASC) {\n      totalCount\n      nodes {\n        formDetailId\n        qOrder\n        qKey\n        qName\n        qType\n        qDefault\n        qOptional\n        qWidth\n        formDetailValuesTsByFormDetailId(orderBy: DISPLAY_ORDER_ASC) {\n          totalCount\n          values: nodes {\n            formDetailValuesId\n            displayOrder\n            text\n            nodeId\n          }\n        }\n        nodeId\n      }\n    }\n    nodeId\n  }\n}\n"
  }
};
})();

node.hash = "6929fbc473df8caaaea9191f4b0ced0e";

module.exports = node;
